<template>
    <path d="M.404 13.21l13.91 11.297c.333.27.796.327 1.188.147.392-.18.64-.57.64-.993v-5.664c5.41.025 9.19.532 13.76 8.446.202.353.58.558.973.558.098 0 .19-.013.287-.038.49-.13.836-.564.836-1.065v-.685c.013-2.987.04-7.498-2.076-11.337-2.428-4.415-7.063-6.793-13.78-7.087v-5.69c0-.424-.247-.815-.64-.995-.39-.18-.854-.12-1.187.148L.405 11.51c-.255.212-.405.52-.405.847 0 .327.144.64.405.853zM13.91 3.43v4.434c0 .602.495 1.095 1.11 1.102 12.466.115 14.412 7.262 14.7 13.112-4.42-5.94-8.643-6.28-14.688-6.28-.294 0-.58.114-.79.32-.21.205-.326.487-.326.775v4.435l-11.03-8.966L13.91 3.43z" fill-rule="evenodd"/>
</template>

<script>
export default {
    name: 'backV1Icon',
    beforeMount() {
        this.$parent.$emit('size', '0 0 32 27');
    }
}
</script>
